import {Injectable} from '@angular/core';
import {RouterStateSnapshot, ActivatedRouteSnapshot, Router, CanActivate} from '@angular/router';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {Store} from "@ngrx/store";
import * as wjcCore from "@grapecity/wijmo";

@Injectable()
export class AdminGuard implements CanActivate {
    user: any;

    constructor(private router: Router, private store: Store<any>) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("kaitoriyaFeature").subscribe((kaitoriya: any) => {
            this.user = kaitoriya.user.user;
        });
    }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        if (wjcCore.isArray(this.user.roles)) {
            for (let role of this.user.roles) {
                // admin ロールは買取屋から外し、業務ライン別ロール「買取屋管理者」へ移行したため
                // 両方を管理者として許可する (買取屋管理者は OrientDB 上 admin を継承)。
                if (role.name == "admin" || role.name == "買取屋管理者") {
                    return true;
                }
            }
        }
        console.log("AdminGuard Not Admin")
        this.router.navigateByUrl('user');
        return false;
    }
}
